import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getPreviewInfo (id) {
        return httpService.get(ApiEndpoints.get('preview_for_donor', { familyId: id }));
    },
    sendGreaterNeeds (data) {
        return httpService.put(
            ApiEndpoints.get('greater_needs', {
                familyId: data.id,
                greaterNeedsflag: data.greaterNeedsFlag
            })
        );
    }
};
